import { User, Zap, Circle, Box, Activity } from 'lucide-react';

export const AVATAR_STYLES = [
    { id: 'nexus', name: 'Nexus', icon: User },
    { id: 'flux', name: 'Flux', icon: Zap },
    { id: 'orb', name: 'Orb', icon: Circle },
    { id: 'retro', name: 'Retro', icon: Box },
    { id: 'beam', name: 'Beam', icon: Activity },
];
